import { CSSCreator } from "../css-definitions/CSSCreator";
import { CSSColor } from "./CSSColor";
import { CSSDisplayType } from "./CSSDisplay";
import { CSSOverflowType } from "./CSSOverflow";
import { CSSPositionType } from "./CSSPosition";
import { CSSLength, FontSizeValue, PercentageValue, PixelValue } from "./CSSUnitValue";
import { CSSWhiteSpaceType } from "./CSSWhiteSpace";
import { CSSCursorType } from "./CSSCursor";
import { CSSTextAlignType } from "./CSSTextAlign";
import { HTMLGradient } from "../dom-ui/basics/Gradient";
import { DomID } from "../dom-tools/DomID";

export class CSS
{
  
  fontFamily:string;
  fontSize:PixelValue | FontSizeValue | PercentageValue;
  display:CSSDisplayType; 
  
  position:CSSPositionType;

  overflow:CSSOverflowType;
  overflowX:CSSOverflowType;
  overflowY:CSSOverflowType;

  width:CSSLength;
  height:CSSLength;
  
  left:CSSLength;
  right:CSSLength;
  top:CSSLength;
  bottom:CSSLength;

  margin:CSSLength|[CSSLength,CSSLength];

  marginTop:CSSLength;
  marginBottom:CSSLength;
  marginLeft:CSSLength;
  marginRight:CSSLength;

  padding:CSSLength|[CSSLength,CSSLength];

  paddingTop:CSSLength;
  paddingBottom:CSSLength;
  paddingLeft:CSSLength;
  paddingRight:CSSLength;

  color:CSSColor;
  backgroundColor:CSSColor;

  static readonly BACKGROUND = "background";
  background:CSSColor|HTMLGradient|HTMLGradient[];
  opacity:number;
  
  borderRadius:CSSLength;
  whiteSpace:CSSWhiteSpaceType;
  cursor:CSSCursorType;
  textAlign:CSSTextAlignType;

  atMedia:string;

  toString()
  {
    let output:string[] = [];
   
    output.push( "{\n" );

    // (\w+):.+?;
    // this._write( "$1", this.$1, output );

    this._write( "font-family", this.fontFamily, output ); 
    this._write( "font-size", this.fontSize, output ); 
    
    this._write( "display", this.display, output ); 
  
    this._write( "position", this.position, output );
  
    this._write( "overflow", this.overflow, output );
    this._write( "overflow-x", this.overflowX, output );
    this._write( "overflow-y", this.overflowY, output );
  
    this._write( "width", this.width, output );
    this._write( "height", this.height, output );

    this._write( "left", this.left, output );
    this._write( "right", this.right, output );
    this._write( "top", this.top, output );
    this._write( "bottom", this.bottom, output );

  
    this._write( "margin", this.margin, output );
  
    this._write( "margin-top", this.marginTop, output );
    this._write( "margin-bottom", this.marginBottom, output );
    this._write( "margin-left", this.marginLeft, output );
    this._write( "margin-right", this.marginRight, output );
  
    this._write( "padding", this.padding, output );
  
    this._write( "padding-top", this.paddingTop, output );
    this._write( "padding-bottom", this.paddingBottom, output );
    this._write( "padding-left", this.paddingLeft, output );
    this._write( "padding-right", this.paddingRight, output );

    this._write( "color", this.color, output );
    this._write( "background-color", this.backgroundColor, output );
    this._write( "background", this.background, output );
    this._write( "opacity", this.opacity, output );
    
    this._write( "borderRadius", this.borderRadius, output );

    this._write( "white-space", this.whiteSpace, output );
    this._write( "cursor", this.cursor, output );
    this._write( "text-align", this.textAlign, output );

    output.push( "}" );

    return output.join( "" );
    
  }
  
  private _write( name:string, value:any, output:string[] )
  {
    if ( ! value )
    {
      return;
    }

    output.push( "  ");
    output.push( name );
    output.push( ": " );
    
    if ( Array.isArray( value ) )
    {
      if ( CSS.BACKGROUND === name )
      {
        output.push( value.join( ", " ) );
      }
      else
      { 
        output.push( value.join( " " ) );
      }
      
    }
    else
    {
      output.push( value );
    }

    
    output.push( ";\n" )
    
  }

  
  appendToDOM( selector:string )
  {
    let css = selector + "\n" + this.toString();

    if ( this.atMedia )
    {
      css = 
`@media ${this.atMedia} 
{
  ${css}
}`
    
    ;
    }


    // console.log( "APPEND TO DOM:\n", css );
    return CSSCreator.appendCSS( css ); 
  }

  appendToElement( element:Element )
  {
    let attributeValue = DomID.getAttributeValue( element );

    this.appendToDOM( attributeValue.selector );
  }
}